export default __webpack_public_path__ + "static/media/vintage65g-2.088e2c93.jpg";